module.exports = __webpack_public_path__ + "7f443dfbd5f7f03984cdaacc4cffdfb8.svg";